export const ROOT: string = "/";

export const LOGIN: string = "/login";
export const FORGOT_PASSWORD_PATH: string = "/forgot-password";
export const REGISTRATION_EMAIL_SENT: string = "/registration/confirm-email";
export const REGISTER_PATH = "/signup";

export const QUICK_START: string = "/dashboard";
export const DASHBOARD: string = "/dashboard";

export const SETTINGS: string = "/settings";

export const UNAUTHORIZED: string = "/401";


export const MY_WORKSPACE: string = `${SETTINGS}/myworkspace`;
export const CREATE_WORKSPACE: string = "/create/workspace";

export const LIFETIME: string = "/lifetime";

export const STORY: string = "/designs/{0}/{1}"
export const CREATE_STORY: string = "/designs/{0}/{1}/{2}"

